// extracted by mini-css-extract-plugin
export default {"mobileOnly":"ResponsiveUIUtils_mobileOnly__aK3Pk","desktopOnly":"ResponsiveUIUtils_desktopOnly__DagUy","disableSmallScreens":"ResponsiveUIUtils_disableSmallScreens__Edraj"};